export function getUnavailabilityReason(reason) {
  const REASONS = {
    not_capable: 'Mangler evner',
    not_available: 'Ikke tilgjengelig',
    reserved: 'Ikke tilgjengelig',
    out_of_range: 'For langt unna',
    fully_booked: 'Fullbooket',
  }

  return REASONS[reason] || REASONS.not_available
}
